Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    modalMotionDuration: "300ms",
    modalMotionFunction: "ease",
    modalBorderWidth: 1,
    modalBorderRadius: 4,
    modalHeaderForegroundColor: "#FFFFFF",
    modalHeaderBackgroundColor: "#0E171D",
    modalHeaderFontWeight: 600,
    modalHeaderMinHeight: 48,
    modalHeaderSpacingInsetTop: 8,
    modalHeaderSpacingInsetBottom: 8,
    modalHeaderSpacingInsetStart: 16,
    modalHeaderSpacingInsetEnd: 40,
    modalCloseButtonSpacingWebTop: 8,
    modalCloseButtonSpacingWebEnd: 8,
    modalCloseButtonSpacingMobileTop: 4,
    modalCloseButtonSpacingMobileEnd: 2,
    modalBodyBackgroundColor: tokens.themePageDefault,
    modalFooterSpacingInset: 16,
    modalFooterBorderWidth: 1,
    modalFooterBorderRadius: 0,
    modalFooterBorderColor: tokens.themeBorderSubdued,
    modalDropShadowOffsetX: 0,
    modalDropShadowOffsetY: 2,
    modalDropShadowBlur: 4,
    modalDropShadowSpread: 0,
    modalDropShadowColor: "#02080E",
    modalDropShadowOpacity: 16,
    modalFloatingBreakpoint: 721
  }
};